import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
    Modal, Button, Row, Col,
} from 'antd';

class DoneStatusModal extends Component {
    render() {
        const {
            visible, onAllOrder, onEPrescription, order_id,
        } = this.props;

        return (
            <Modal
                visible={visible}
                // onCancel={onCancel}
                footer={null}
            >
                <div>

                    <h2 style={{ textAlign: 'center' }}>Order is created, order ID - {order_id}</h2>

                    <br /><br />

                    <Row type="flex" justify="space-around">
                        <Col>
                            <Button type="primary" onClick={onAllOrder}>
                                Go to all Orders
                            </Button>
                        </Col>

                        <Col>
                            <Button type="primary" onClick={onEPrescription}>
                                Add e-prescription
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    order_id: state.AppState.order_id,
    // medicineList: state.AppState.medicineList,
});

// const mapDispatchToProps = dispatch => {
//     return {
//         // setOrderValuesInStore: (data) => dispatch({type: ADD_PATIENT_DETAILS, data: data}),
//     }
// };

export default connect(mapStateToProps, null)(DoneStatusModal);



// WEBPACK FOOTER //
// ./src/component/AddOrder/DoneStatusModal.js